import { useMemo } from 'react';
import '../css/InAppBrowserBanner.css';
import { isInAppBrowser, openInExternalBrowser, stripTrackingParams } from '../utils/inAppBrowserUtil';
import { IN_APP_BROWSER_BANNER_TEXT, IN_APP_BROWSER_BANNER_LINK_TEXT } from '../constants/bookingConst';

/**
 * Top-of-page banner shown only when the app is opened from a social-media
 * link (Facebook, Messenger, Instagram, TikTok, ...). It links to the same
 * page opened in the device's real browser. Renders nothing otherwise.
 *
 * @returns {JSX.Element|null}
 */
function InAppBrowserBanner() {
  // UA never changes during a session, so detect once.
  const inApp = useMemo(() => isInAppBrowser(), []);
  if (!inApp) return null;

  /**
   * Reopens the current page in the external browser (see
   * openInExternalBrowser for the per-platform handling).
   *
   * @param {React.MouseEvent<HTMLAnchorElement>} event
   */
  const handleOpen = (event) => {
    event.preventDefault();
    openInExternalBrowser();
  };

  return (
    <div className="iab-banner" role="region" aria-label="Open in browser">
      <span>
        {IN_APP_BROWSER_BANNER_TEXT}{' '}
        <a
          href={typeof window !== 'undefined' ? stripTrackingParams(window.location.href) : '/'}
          className="iab-banner-link"
          onClick={handleOpen}
        >
          {IN_APP_BROWSER_BANNER_LINK_TEXT}
        </a>.
      </span>
    </div>
  );
}

export default InAppBrowserBanner;
